import { Spinner } from "./styles/common.styled"

export const Loading = ({ sm }: { sm?: boolean }) => {
    return (
        <Spinner sm />
    )
}